import { useTranslation } from 'react-i18next';

import { ColumnDefinitionType } from '@components/molecules/ListTable/ListTable';

import { useResponsive } from '@utils/hooks/useResponsive';

export interface ColumnsProps {
    approvalStatusCell: React.ReactNode;
    id: string;
    lastMessageDate: Date | string;
    lastMessageDateCell: React.ReactNode;
    message: string;
    messageCell: React.ReactNode;
    status?: 'none' | 'new' | 'seen';
    statusCell: React.ReactNode;
    submissionCell: React.ReactNode;
    submissionDate?: Date | null;
}

type Columns = ColumnDefinitionType<ColumnsProps>[];

export const useFilledDisclosuresListColumns = () => {
    const { t } = useTranslation();
    const isXs = useResponsive('xs');
    const isSm = useResponsive('sm');
    const isXxs = useResponsive('xxs');

    const columns: Columns = [
        {
            flex: 2,
            isMain: false,
            key: 'submissionCell',
            label: t('DISCLOSURE_ANSWER_HEADER_SUBMISSION'),
            minWidth: !isXxs ? 180 : 120,
        },
        ...(!isXxs
            ? [
                  {
                      flex: 2,
                      isMain: false,
                      key: 'approvalStatusCell' as keyof ColumnsProps,
                      label: t('STATUS'),
                      minWidth: 80,
                  },
              ]
            : []),
        {
            flex: 1,
            isMain: false,
            key: 'statusCell',
            label: '',
        },
        ...(!isXs
            ? [
                  {
                      flex: 5,
                      isMain: true,
                      key: 'messageCell' as keyof ColumnsProps,
                      label: t('DISCLOSURE_ANSWER_HEADER_MESSAGE'),
                      maxWidth: 500,
                  },
              ]
            : []),
        ...(!isSm
            ? [
                  {
                      flex: 3,
                      isMain: true,
                      key: 'lastMessageDateCell' as keyof ColumnsProps,
                      label: t('LAST_MESSAGE_DATE'),
                      minWidth: 135,
                  },
              ]
            : []),
    ];

    return { columns };
};
